export default {
  // Režiimid
  "common.mode.auto": "Isekasutamine",
  "common.mode.economy": "Majandusrežiim",
  "common.mode.exigency": "Erarežiim",

  // Seadmed
  "common.grid": "Elektriverk",
  "common.evChargers": "Laadijad",
  "common.evCharger": "Laadija",
  "common.pv": "Päikeseenergia",
  "common.inverter": "Inverter",
  "common.pcs": "Inverter + Akumulaator",
  "common.terminal": "Terminalseade",
  "common.airc": "Kliimaseade",
  "common.engine": "Mootor",
  "common.battery": "Akumulaator",
  "common.metter": "Elektriarvesti",
  "common.other": "Muu",
  "common.power": "Võimsus",
  "common.powerTotal": "Koguvõimsus",
  "common.voltage": "Pinge",
  "common.electricity": "Energiakogus",
  "common.current": "Voolutugevus",
  "common.homeUsage": "Kodu kogukoormus",
  "common.battery.power": "Aku võimsus",

  // Andmed
  "common.noDataAvailable": "Andmed puuduvad",
  "common.tips": "Vihje",
  "common.reset": "Lähtesta",
  "common.currencyUnit": "¥",
  "common.submiting": "Saadan, palun oodake...",
  "common.close": "Sulge",
  "common.from": "Allikast",
  "common.useIn": "Kasutatakse",
  "common.energyPercent": "Energiavoogude osakaal",
  "common.dataFlow": "Andmevoog",
  "common.getDataIng": "Laen andmeid, palun oodake...",
  "common.pageLoading": "Lehte laaditakse, palun oodake...",
  "common.reseting": "Lehe sisu lähtestatakse, palun oodake...",
  "common.save": "Salvesta",
  "common.onlyNumberTips": "Sisestage ainult numbreid",
  "common.offline": "Offline",
  "common.online": "Online",
  "common.fault":"Viga",
  "common.charge": "Laadimine",
  "common.discharge": "Tühjendamine",
  "common.buy": "Ost",
  "common.sell": "Müük",
  "common.loadingInfo": "Laen, palun oodake...",

  // 
  "common.moreFeatures": "Rohkem funktsioone",
  "common.confirm": "Kinnita",
  "common.saveing": "Salvestan, palun oodake...",
  "common.searchPlacholder": "Sisestage otsingumärksõna",
  "common.iSee": "Sain aru",
  "common.pageErrorTips1": "Oih, lehel tekkis viga",
  "common.pageErrorTips2": "Proovige lehte värskendada või võtke ühendust klienditeenindusega",
  "common.refresh": "Värskenda",
  "common.backToHome": "Tagasi avalehele",
  "common.checkTips": "Kontrollin, palun oodake...",
  "common.back": "Tagasi",
  "common.cancel": "Tühista",
  "common.optional": "Valikuline",
  "common.required": "Kohustuslik",
  "common.status": "Olek",
  "common.statusNoDelete": "Kustutamata",
  "common.statusDelete": "Kustutatud",
  "common.submit": "Esita",
  "common.disable": "Keela",
  "common.enable": "Luba",
  "common.year": "aasta",
  "common.month": "kuu",
  "common.day": "päev",
  "common.version": "Versioon:",
  "common.backHome": " Tagasi avalehele",
  "common.backHomeSorry": " Vabandame, leht on ära eksinud",
  "common.requestTips1": "Andmeid töödeldakse, ärge esitage uuesti",
  "common.requestTips2": "Süsteemiteade",
  "common.requestTips3": "Sisselogimise seanss on aegunud, logige uuesti sisse",
  "common.requestTips4": "Logi uuesti sisse",
  "common.requestTips5": "Vigane seanss või seanss on aegunud, logige uuesti sisse",
  "common.requestTips6": "Serveri viga, proovige palun hiljem uuesti.",
  "common.requestTips7": "Süsteemi päringu aegumine",
  "common.requestTips8": "Süsteemi liides",
  "common.requestTips9": "Viga",
  "common.iknow": "Sain aru",
  "common.logoutSuccess": "Väljalogimine õnnestus",
  
  // Lisateave komponent
  "common.knowMore.title": "Lisateabe saamiseks võtke ühendust BeiNengiga",
  "common.knowMore.email": "E-post",
  "common.knowMore.phone": "Telefon",
  "common.knowMore.wechat": "WeChat",
  "common.knowMore.website": "Koduleht",
  "common.knowMore.address": "Aadress",
  "common.knowMore.addressDetail": "Ruum 1205 ja 1305, Hoone 5, Qinghe tee 8, Huangjingkeng, Huangjiang linn, Dongguan, Guangdong provints",
  
  // Kohalik ühendus komponent
  "common.localConnection": "Kohalik ühendus",
  "common.operateInApp": "Palun tegutsege rakenduses!",
  
  "common.enbleStaus": "Lubatud olek",
  "common.battery.status": "Ei laadi ega tühjenda",

  "account.forgetThePassword": "Unustasite parooli",
    "account.logInDirectly": "Mine otse sisselogimisele",
    "account.tips1": "Ümbersuunamine, palun oodake...",
    "account.tips2": "Palun lugeda ja nõustuda kasutajatingimustega!",
    "account.autoLogin": "Automaatne sisselogimine",
    "account.userLogin": "Kasutaja sisselogimine",
    "account.registerTips": "Pole veel kontot? Klõpsake registreerumiseks",
    "account.userEmail": "Kasutajanimi/E-post",
    "account.userEmailTips": "Sisestage kasutajanimi/e-post",
    "account.password": "Parool",
    "account.passwordTips": "Sisestage parool",
    "account.submit": "Esita",
    "account.submitTips": "Esitan, palun oodake...",
    "account.otherLoginTips": "Või valige muu sisselogimise viis",
    "account.userRegistration": "Kasutaja registreerimine",
    "account.userName": "Kasutajanimi",
    "account.userNameTips": "Sisestage kasutajanimi",
    "account.emailTips1": "Sisestage e-posti aadress",
    "account.emailTips2": "Vale e-posti aadressi vorming",
    "account.phone": "Telefoninumber",
    "account.phoneTips1": "Sisestage telefoninumber",
    "account.phoneTips2": "Vale telefoninumber",
    "account.phoneTips3": "Sisestage telefoninumber",
    "account.passwordTips1": "Sisestage 6-30 tähemärki pikk parool",
    "account.passwordTips2": "Vale parooli vorming. Parool peab koosnema tähtedest, numbritest, alakriipsudest, sidekriipsudest ja punktidest, pikkus 6-12 tähemärki",
    "account.passwordTips3": "Paroolid ei kattu, kontrollige ja proovige uuesti!",
    "account.passwordTips4": "Sisestage parool. Parool peab koosnema tähtedest, numbritest, alakriipsudest, sidekriipsudest ja punktidest",
    "account.passwordTips5": "Kinnita parool",
    "account.passwordTips6": "Sisestage kinnitamise parool",
    "account.passwordTips7": "Paroolid ei kattu, kontrollige ja proovige uuesti!",
    "account.passwordTips8": "Sisestage kinnitamise parool",
    "account.passwordTips9": "Õnnitleme! Registreerimine õnnestus!",
    "account.passwordTips10": "Teie kasutajanimi on:",
    "account.emailIs": "E-post on:",
    "account.goToLoginPage": "s suunatakse automaatselt sisselogimislehele",
    "account.goLogin": "Logi sisse",
    "account.goRegister": "Registreeri",
    "account.loginSuccess": "Sisselogimine õnnestus",
    "account.email": "E-post",
    "account.sologn": "Kohandatud energialahendused hoolikalt",
    "account.pleaseAgree": "Olen lugenud ja nõustun",
    "userAgreement.privacyPolicy": "Privaatsuspoliitika",

    "account.code": "Kinnituskood",
    "account.codeTips": "Sisestage kinnituskood",
    "account.codeTips2": "Vale kinnituskood",

    "account.inviteCodeTips": "Palun sisestage kutsekood",
    "account.inviteCodeHint": "Kutsekoodi saamiseks võtke ühendust paigaldaja või hooldustöötajaga",
    "account.modifyPasswordByAccount": "Muuda parooli kontoga",
    "account.modifyPasswordByEmail": "Muuda parooli e-posti teel",
    "account.getPasswordByAccount": "Taasta parool kontoga",
    "account.getPasswordByEmail": "Taasta parool e-posti teel",

    "account.sendEmailTips": "Kinnituskood saadetud e-postile, kontrollige oma postkasti",
    "account.name": "Konto nimi",
    "account.newPassword": "Uus parool",
    "account.confirmNewPassword": "Kinnita uus parool",
    "account.nameTips": "Sisestage konto nimi",
    "account.passwordModifySuccess": "Parooli muutmine õnnestus",
    "account.emailCode": "E-posti kinnituskood",
    "account.emailCodeTips": "Sisestage e-posti kinnituskood",
    "account.emailCodeTips2": "Vale e-posti kinnituskood",
    "account.emailModifySuccess": "Parooli muutmine õnnestus",
    "account.passworTips1": "Teie parool on lähtestatud!",
    "account.passwordTips11": "Sisestage kinnitamise parool",
    "account.passwordTips12": "Sisestage uus parool",
    "account.nickname": "Kasutajanimi",
    "account.modifyNickname": "Muuda kasutajanime",
    "account.modifyNicknameSuccess": "Kasutajanimi muudetud!",
    "account.nicknameError": "Kasutajanime muutmine ebaõnnestus!",

    "account.login": "Logi sisse",
    "account.quickRegister": "Kiire registreerimine",
    "account.sendCode": "Saada kinnituskood",
    "account.sendTips": "s saab uuesti saata",
    "account.sendEmailIng": "Saadan e-kirja, palun oodake...",
    "account.emailNotEmpty": "E-posti aadress ei tohi olla tühi",
    "account.registerAccount": "Registreeri konto",
    "account.registerWelcome": "Tere tulemast SusprSafe-i",
    "account.usernameLimit": "Kasutajanimi peab algama tähega ja võib sisaldada ainult tähti, numbreid ja alakriipse, pikkus 5-15 tähemärki",

    "copyright.desc2": "Veebilehe registreerimisteave: Yue ICP-bei 2021169764",

    "editUserInfo.editUserInformation": "Muuda kasutajateavet",
    "editUserInfo.modifyUsername": "Muuda kasutajanime",
    "editUserInfo.changePictures": "Muuda profiilipilti",
    "editUserInfo.savePicturesSuccess": "Profiilipilt salvestatud",
    "editUserInfo.saveError": "Salvestamine ebaõnnestus",
    "editUserInfo.pictureLimit":"Pilt peab olema väiksem kui 2MB",
    "editUserInfo.uploadPicture":"Lae üles profiilipilt",
    "editUserInfo.picturePreview": "Eelvaade",
    
    "editUserInfo.bindPhoneNumber": "Seo telefoninumber",
    "editUserInfo.bindEmail": "Seo e-post",
    "editUserInfo.changePassword": "Muuda parooli",

    "editUserInfo.notificationSettings": "Teatiste seaded",
    "editUserInfo.editAccount": "Muuda konto teavet",
    "editUserInfo.waitBingting": "Sean, palun oodake...",
    "editUserInfo.collapse": "Ahenda",
    "editUserInfo.modifyBinding": "Muuda seost",
    
    "editUserInfo.emailAddress": "E-posti aadress",
    "editUserInfo.tips1": "E-posti seostamine õnnestus",
    "editUserInfo.tips2": "Salvestamine ebaõnnestus",
    "editUserInfo.tips3": "Saadan e-posti kinnituskoodi, palun oodake...",
    "editUserInfo.tips4": "Kinnituskood saadetud e-postile xxxx, kontrollige",
    "editUserInfo.tips5": "Kinnituskoodi saatmine ebaõnnestus!",
    "editUserInfo.tips6": "Telefoninumber juba seotud",
    "editUserInfo.tips7": "E-post juba seotud",
    "editUserInfo.emailTips1": "Sisestage e-posti aadress",
    "editUserInfo.emailTips2": "Vale e-posti aadressi vorming",
    "editUserInfo.emailTips3": "xxxxs saab uuesti saata",
    "editUserInfo.emailTips4": "Saada kinnituskood",
    "editUserInfo.emailTips5": "E-posti kinnituskood ei tohi olla tühi",
    "editUserInfo.emailTips6": "Vale e-posti kinnituskood",
    "editUserInfo.emailCode": "E-posti kinnituskood",
    "editUserInfo.save": "Salvesta",

    "editUserInfo.phoneTips1": "Telefoninumbri seostamine õnnestus",
    "editUserInfo.phoneTips2": "Saadan SMS kinnituskoodi, palun oodake...",
    "editUserInfo.phoneTips3": "SMS kinnituskood saadetud telefonile xxxx, kontrollige",
    "editUserInfo.phoneTips4": "SMS kinnituskoodi saatmine ebaõnnestus!",
    "editUserInfo.phoneTips5": "Sisestage telefoninumber",
    "editUserInfo.phoneTips6": "Vale telefoninumbri vorming",
    "editUserInfo.phoneTips7": "Saada SMS kinnituskood",
    "editUserInfo.phoneTips8": "SMS kinnituskood",
    "editUserInfo.phoneTips9": "Telefoni kinnituskood ei tohi olla tühi",
    "editUserInfo.phoneTips10": "Vale telefoni kinnituskood",
    "editUserInfo.phone": "Telefoninumber",


    "editUserInfo.noticeTips1": "Teatiste seadete hankimine ebaõnnestus!",
    "editUserInfo.noticeTips2": "Teatiste seaded salvestatud!",
    "editUserInfo.noticeTips3": "Teade madala aku taseme kohta",
    "editUserInfo.noticeTips4": "Teade laadimise lõpetamise kohta",
    "editUserInfo.errorNotification": "Veateade",
    "editUserInfo.updateNotification": "Värskendusteatis",
    "editUserInfo.monthlyStatisticsNotification": "Kuise statistika teatis",
    "editUserInfo.notificationMethod": "Vastuvõtumeetod",

    "editUserInfo.userNameTips1": "Kasutajanimi salvestatud",
    "editUserInfo.userNameTips2": "Kasutajanime salvestamine ebaõnnestus",
    "editUserInfo.userNameTips3": "Sisestage kasutajanimi",
    "editUserInfo.userNameTips4": "Vale kasutajanime vorming. Peab koosnema numbritest, alakriipsudest ja tähtedest",
    "editUserInfo.userNameTips5": "Sisestage kasutajanimi",
    "editUserInfo.userNameTips6": "Salvestan, palun oodake...",
    "editUserInfo.userName": "Kasutajanimi",

    "editUserInfo.avatorTips": "Klõpsake profiilipildi muutmiseks",
    "editUserInfo.verifyCodeTips1": "Sisestage saadud kinnituskood:",
    "editUserInfo.verifyCodeTips2": "Konto turvalisuse huvides klõpsake nuppu kinnituskoodi saatmiseks algsele telefoninumbrile:",
    "editUserInfo.verifyCodeTips3": "Saada kinnituskood",
    "editUserInfo.verifyCodeTips4": "Algne telefon kinnitatud, sisestage uus seotav telefoninumber",
    "editUserInfo.verifyCodeTips5": "Konto turvalisuse huvides klõpsake nuppu kinnituskoodi saatmiseks algsele e-postile:",
    "editUserInfo.verifyCodeTips6": "Algne e-post kinnitatud, sisestage uus e-post",
    "editUserInfo.verifyCodeTips7": "Vana parool",
    "editUserInfo.verifyCodeTips8": "Palun seo kõigepealt e-post!",
    "editUserInfo.verifyCodeTips9": "Kinnituskood saadetud e-postile, kontrollige oma postkasti",
    "editUserInfo.verifyCodeTips10": ", suunatakse automaatselt sisselogimislehele",

    "hems.notice.title": "Teatise pealkiri", 
   "hems.notice.content": "Teatise sisu", 
   "hems.notice.operate": "Toiming",
   "hems.notice.noRead": "Lugemata",
   "hems.notice.read": "Loetud",
   "hems.notice.warning": "Hoiatus",
   "hems.notice.error": "Viga",
   "hems.notice.success": "Statistika ja arvestus",
   "hems.notice.sys": "Süsteemiinfo",
   "hems.notice.operateSuccess": "Toiming õnnestus",
   "hems.notice.operateTips": "Valige toiminguteks objektid",

    // Avaleht
   "hems.home.selfuseRate": "Isekasutamise määr",
   "hems.home.percent": "Protsent",
   "hems.home.todayData": "Tänased andmed",
   "hems.home.todayPowerGeneration": "Tänane elektritootmine",
   "hems.home.salesIncome": "Tulu elektri müügist",
   "hems.home.saved": "Olete säästnud",
   "hems.home.reduce": "Vähendatud süsiniku jalajälg",
   "hems.home.tips1": "Andmed puuduvad, te pole seostanud xxxx",
   "hems.home.criticalLoad": "Kriitiline koormus",
   "hems.home.keyVoltage": "Kriitiline pinge",
   "hems.home.householdLoad": "Kodukoormus",
   "hems.home.householdVoltage": "Kodupinge",
   "hems.home.generalLoad": "Üldkoormus",
   "hems.home.generalVoltage": "Üldpinge",
   "hems.home.batteryHealth": "Aku tervis",
   "hems.home.averageTemp": "Keskmine temperatuur",
   "hems.home.gridLoad": "Võrgu koormus",
   "hems.home.toggeleDataSource": "Kuvatavad andmed vahetatud:",
   "hems.home.toggleTips": "Kas soovite kindlasti vahetada?",
   "hems.home.modeSending": "Režiimi käsk saadetakse, palun oodake...",
   "hems.home.modeSuccess": "Režiimivahetuse käsk saadetud!",
   "hems.home.isOnline": "Kas online",
   "hems.home.useStatus": "Kasutamise olek",
   "hems.home.workModeText": "Praegune töörežiim:",
   "hems.home.toggleDataSourceText": "Kuvatavad andmed vahetatud:",
   "hems.ev.charge.status": "Laadimise olek",
   "hems.ev.charge.time": "Laadimise kestus",
   "hems.ev.charge.count": "Reaalaja laadimise kogus",
   "hems.ev.charge.status.empty":"Vaba",
   "hems.ev.charge.status.ing":"Laadimine pistiku ühendamisel",
   "hems.ev.charge.status.null":"Pistik ühendatud, ei laadi",
   "hems.ev.charge.status.error":"Viga",
   "hems.hour":"tundi",
   "hems.minue":"minutit",
   "hems.ev.chagre.number": "Laadija number",

   // Kasutajajuhend
   "hems.userGuide.selfUse": "Isekasutamine",
   "hems.userGuide.selfUseTips": "Eelistatakse päikeseenergiat, puudujääk täiendatakse võrgust",
   "hems.userGuide.economyMode": "Majandusrežiim",
   "hems.userGuide.economyModeTips": "Optimeerib energiatarbimist elektrihindade alusel",
   "hems.userGuide.emergencyMode": "Erarežiim",
   "hems.userGuide.emergencyModeTips": "Tagab eelkõige kriitilise koormuse toite",

   // Graafiku leht
   "hems.history.energyStatistics": "Energia statistika",
   "hems.history.revenueStatistics": "Tulu statistika",
   "hems.history.greenStatistics": "Roheline mõju",
   "hems.history.revenueTitle": "Kogutulu elektri müügist",
   "hems.history.savingsTitle": "Kogusääst",
   "hems.history.carbonTitle": "Kogu vähendatud süsihappegaasi heide",
   "hems.history.day": "Päev",
   "hems.history.month": "Kuu",
   "hems.history.year": "Aasta",
   "hems.history.beforeDay": "Eelmine päev",
   "hems.history.afterDay": "Järgmine päev",
   "hems.history.beforeMonth": "Eelmine kuu",
   "hems.history.afterMonth": "Järgmine kuu",
   "hems.history.beforeYear": "Eelmine aasta",
   "hems.history.afterYear": "Järgmine aasta",
   "hems.history.totalUse": "Kogukasutus",
   "hems.history.fullScreen": "Täisekraan",
   "hems.history.timeSelect": "Kuupäeva valik",
   "sync.tips1": "Sünkroonimise käsk saadetud!",
   "sync.tips2":"Andmete sünkroonimine käib, võib võtta kuni pool tundi, tulge hiljem tagasi~",
   "sync.tips3": "Seadme andmete sünkroonimine võib viibida. Kui andmed tunduvad ebatäpsed, klõpsake:",
   "sync.tips4": "Sünkrooni andmed",

   "charge.info": "Laadija teave",
    "news.loading": "Laen...",
    "news.noMore": "Rohkem pole",
    "hems.pv.power": "Päikeseenergia toide",

  // UEH spetsiifiline
  "ueh.sellPower": "Müüdud elektri kogus",
  
  "menu.home": "Avaleht",
  "menu.history": "Ajalugu",
  "menu.device": "Seadmed",
  "menu.settings": "Seaded",
  "menu.messageCenter": "Teated",
  "menu.help": "Abi ja tugi",
  "menu.mine": "Minu konto",


  "mine.userSetting": "Kasutaja seaded",
  "mine.terminalSetting": "Terminali põhiseaded",
  "mine.uploadCloud": "Andmete varundamine pilve",
  "mine.changeVersion": "Kontrolli uuendusi",
  "mine.language": "Muuda keelt",
  "mine.about": "Info",
  "mine.feedback": "Tagasiside",
  "mine.logout": "Logi välja",
  "mine.logoutAccount": "Kustuta konto",

  "mine.logoutAccountTips": "Kustuta konto nimega []",
  "mine.logoutAccountTips1": "Kustuta [] seotud konto",
  "mine.logoutAccountCare": "Konto kustutamise olulised punktid:",
  "mine.logoutAccountCare1": "1. Konto on turvalises olekus",
  "mine.logoutAccountCare1-1": "Kontot kasutatakse normaalselt, pole ohtu varastamise, rikkumise, keelamise jms suhtes",
  "mine.logoutAccountCare2": "2. Konto õigused/seosed on tühistatud",
  "mine.logoutAccountCare2-1": "Konto on lõpetanud õigused kolmandate osapoolteenustega",
  "mine.logoutAccountCare3": "3. Kontot ei saa pärast kustutamist taastada, kõik andmed kustutatakse",
  "mine.logoutAccountCare3-1": "Pärast konto kustutamist kõik andmed ja seotud telefoninumbrid/e-posti aadressid eemaldatakse jäädavalt",
  "mine.confirmLogout": "Kinnita kustutamine",
  "mine.logoutSuccess": "Konto kustutatud!",

  "mine.feedbackIssues": "Teata probleemidest",
  "mine.feedQuantity": "Kogus",
  "mine.feedAmount": "Maksimaalselt 9 pilti, maksimaalselt 1MB/pilt",

  "mine.notice.fail": "Teatiste seadete hankimine ebaõnnestus!",
  "mine.notice.saveSuccess": "Teatiste seaded salvestatud!",
  "mine.notice.saveFail": "Salvestamine ebaõnnestus!",
  "mine.notice.title": "Teatiste seaded",
  "mine.notice.batteryLow": "Teade madala aku taseme kohta",
  "mine.notice.chargingFinish": "Teade laadimise lõpetamise kohta",
  "mine.notice.error": "Veateade",
  "mine.notice.update": "Värskendusteatis",
  "mine.notice.monthly": "Kuise statistika teatis",
  "mine.notice.receiveType": "Vastuvõtumeetod",

  "mine.language.welcome": "Tere tulemast SusprSafe-i",
  "mine.language.desc1": "Valige keeleversioon vastavalt oma piirkonnale",
  "mine.language.desc2": "Saate seda muuta rakenduse seadetest igal ajal",

  "mine.userInfo.avatar":"Profiilipilt",
  "mine.userInfo.nickname":"Kasutajanimi",
  "mine.userInfo.password":"Parool",
  "mine.userInfo.changePassword":"Muuda parooli",
  "mine.userInfo.setPassword":"Määra parool",
  "mine.userInfo.phoneNumber":"Telefoninumber",
  "mine.userInfo.bindPhone":"Seo telefoninumber",
  "mine.userInfo.bindEmail":"Seo e-post",
  "mine.loginExpired":"Sisselogimine aegunud, logige uuesti sisse",
  "mine.userInfo.title":"Kasutaja teave",
  "mine.userInfo.bind":"Seo",
  "mine.userInfo.modify": "Muuda",
  "mine.userInfo.modifyNickname":"Muuda kasutajanime",
  "mine.userInfo.userNickname":"Kasutajanimi",
  "mine.userInfo.selectPic":"Valige üleslaadimiseks pilt",
  "mine.userInfo.saveSuccess":"Salvestatud",
  "mine.userInfo.uploadFail":"Üleslaadimine ebaõnnestus",
  "mine.userInfo.avatarSaveSuccess":"Profiilipilt salvestatud",
  "mine.userInfo.nameTips1":"Kasutajanimi ei tohi olla tühi",
  "mine.userInfo.nameTips2":"Sisestage kasutajanimi",

  "common.pleaseSelect": "Palun valige",
  "question.commonQuestions": "KKK",
  "account.toggleLanguage": "Muuda keelt",
  "account.localConnection": "Kohalik ühendus",
  "account.selectLanguage": "Valige keel",
  "account.sendEmailToast": "Kinnituskood saadetud e-postile xxx, kontrollige oma postkasti",
  "account.emailError": "Vale e-posti aadress",
  "account.sendEmailFail": "Saatmine ebaõnnestus, proovige uuesti",

  "common.submitting": "Esitan, palun oodake...",

  "device.page.noData": "Andmed puuduvad, seda lehte saab vaadata ainult rakenduses",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
 
};